module.exports = __webpack_public_path__ + "img/pampasblonde_hair.0c1456a0.jpg";